import { render } from "./ClientCambioClaveToken.vue?vue&type=template&id=05551550&scoped=true"
import script from "./ClientCambioClaveToken.vue?vue&type=script&lang=js"
export * from "./ClientCambioClaveToken.vue?vue&type=script&lang=js"

import "./ClientCambioClaveToken.vue?vue&type=style&index=0&id=05551550&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05551550"]])

export default __exports__